import {Component, Input} from '@angular/core';
import {Contact} from "../../model/contact";
import {ModalsService} from "../../services/modals.service";

@Component({
  selector: 'app-contact-info-modal',
  templateUrl: './contact-info-modal.component.html',
  styleUrls: ['./contact-info-modal.component.css']
})
export class ContactInfoModalComponent {
  @Input() contact: Contact;

  constructor(private readonly modalsService: ModalsService) {
  }

  close(): void {
    this.modalsService.hideModal();
  }

  edit(): void {
    this.modalsService.showEditContact(this.contact);
  }

  delete(): void {
    this.modalsService.showDeleteContact(this.contact);
  }
}
